import { UserRole } from 'app-types';
import { Settings } from 'icons';
import { FormattedMessage } from 'localization';

import { EnumDeskRoutes, EnumGeneralSettingRoutes } from '../../../constants';
import { SettingsSidebarMenuItem } from '../AdminSettingsSidebar';
import { adminRoles } from './deskSection';

const generalSettingsSection: SettingsSidebarMenuItem = {
  icon: <Settings width={24} height={24} />,
  data: [
    {
      value: `/${EnumDeskRoutes.settings}/${EnumGeneralSettingRoutes.general}/${EnumGeneralSettingRoutes.subscription}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="settings.subs.tab.subs" />
        </div>
      ),
      roles: adminRoles,
    },
    {
      value: `/${EnumDeskRoutes.settings}/${EnumGeneralSettingRoutes.general}/${EnumGeneralSettingRoutes.billing}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="general.billing-data" />
        </div>
      ),
      roles: adminRoles,
    },
    {
      value: `/${EnumDeskRoutes.settings}/${EnumGeneralSettingRoutes.general}/${EnumGeneralSettingRoutes.integrations}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="general.integrations" />
        </div>
      ),
      roles: adminRoles,
    },
    {
      value: `/${EnumDeskRoutes.settings}/${EnumGeneralSettingRoutes.general}/${EnumGeneralSettingRoutes.thirdPartyIntegrations}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="general.third-party" />
        </div>
      ),
      roles: adminRoles,
    },
    {
      value: `/${EnumDeskRoutes.settings}/${EnumGeneralSettingRoutes.general}/${EnumGeneralSettingRoutes.userSettings}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="general.user-settings" />
        </div>
      ),
      roles: [UserRole.user, UserRole.customerSupport, UserRole.warehouse, ...adminRoles],
    },
    {
      value: `/${EnumDeskRoutes.settings}/${EnumGeneralSettingRoutes.general}/${EnumGeneralSettingRoutes.userManagement}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="general.user-management" />
        </div>
      ),
      roles: adminRoles,
    },
    {
      value: `/${EnumDeskRoutes.settings}/${EnumGeneralSettingRoutes.general}/${EnumGeneralSettingRoutes.publicApi}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="settings.open-api.panel.title-normalcase" />
        </div>
      ),
      roles: adminRoles,
    },
  ],
  translationKey: 'general.general-settings',
};

export { generalSettingsSection };
